// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/transfer/v1/transfer.proto (package kitecorp.transferify.transfer.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/transfer/v1/transfer.proto.
 */
export const file_kitecorp_transferify_transfer_v1_transfer: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Everything an owner's transfer row reads about the transfer itself: its identity, its note, its expiry, its
 * recipients and the verdicts on what may be done with it. It carries no files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.TransferState
 */
export type TransferState = Message<"kitecorp.transferify.transfer.v1.TransferState"> & {
  /**
   * The transfer's id, a UUID.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The transfer's id in the URL-safe opaque form the sender's reconnect and control frames use.
   *
   * @generated from field: string encoded_id = 2;
   */
  encodedId: string;

  /**
   * The sender's note. Absent when the transfer was sent without one.
   *
   * @generated from field: optional string message = 3;
   */
  message?: string | undefined;

  /**
   * Whether the transfer keeps its files online.
   *
   * @generated from field: bool keep_online = 4;
   */
  keepOnline: boolean;

  /**
   * A counter that only grows with each change to the transfer's file set, which a peer-to-peer reconnect compares to
   * learn whether its file list is current.
   *
   * @generated from field: int64 p2p_file_revision = 5;
   */
  p2pFileRevision: bigint;

  /**
   * Whether the sender asked for an email alert on each download.
   *
   * @generated from field: bool notify_on_download = 6;
   */
  notifyOnDownload: boolean;

  /**
   * The retention the transfer was sent with. EXPIRE_AFTER_UNSPECIFIED for a legacy transfer recorded without one.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.ExpireAfter expire_after = 7;
   */
  expireAfter: ExpireAfter;

  /**
   * When the transfer was created. Absent only for a transfer recorded without it.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * The transfer's current email recipients, sorted. Empty for a transfer sent as a link only.
   *
   * @generated from field: repeated string recipients = 9;
   */
  recipients: string[];

  /**
   * The current names of the contact groups the transfer was sent to, in alphabetical order whatever their case. A
   * group renamed since is named by its new name and a group deleted since is left out. Empty for a transfer sent to
   * no group.
   *
   * @generated from field: repeated string recipient_groups = 10;
   */
  recipientGroups: string[];

  /**
   * When the download link stops working. It outlives created_at plus expire_after for a recovered transfer. Absent:
   * the link never expires.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 11;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * Whether the transfer can be recovered now.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState.RecoveryState recovery_state = 12;
   */
  recoveryState: TransferState_RecoveryState;

  /**
   * The deadline for spending the recovery, which is also when the kept files are deleted. Absent when the transfer
   * carries no recovery window.
   *
   * @generated from field: google.protobuf.Timestamp recoverable_until = 13;
   */
  recoverableUntil?: Timestamp | undefined;

  /**
   * Whether files can be added to the transfer.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState.FileAdditionState file_addition_state = 14;
   */
  fileAdditionState: TransferState_FileAdditionState;

  /**
   * Whether the transfer is complete for delivery: it has files, and each is stored or registered for peer delivery.
   * It says nothing about whether the sender is still connected.
   *
   * @generated from field: bool complete = 15;
   */
  complete: boolean;

  /**
   * Whether abuse reports suspended the transfer. Only the fact is carried: the category, the reporters and their
   * number are withheld from the owner.
   *
   * @generated from field: bool suspended = 16;
   */
  suspended: boolean;

  /**
   * Whether the transfer was sent zero-knowledge: its files are encrypted and their keys live only in the link's
   * fragment.
   *
   * @generated from field: bool zero_knowledge = 17;
   */
  zeroKnowledge: boolean;

  /**
   * Whether the owner placed the transfer under legal hold.
   *
   * @generated from field: bool legal_hold = 18;
   */
  legalHold: boolean;

  /**
   * Whether the transfer could be placed under legal hold now.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState.LegalHoldState legal_hold_state = 19;
   */
  legalHoldState: TransferState_LegalHoldState;

  /**
   * How many recipient downloads the owner's monthly allowance refused so far this UTC month. Zero when none.
   *
   * @generated from field: int32 refused_downloads = 20;
   */
  refusedDownloads: number;

  /**
   * The name of the company the transfer was sent as. Absent when it was sent as a person.
   *
   * @generated from field: optional string company = 21;
   */
  company?: string | undefined;

  /**
   * The company's tax id. Absent when the sender gave none.
   *
   * @generated from field: optional string tax_id = 22;
   */
  taxId?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.TransferState.
 * Use `create(TransferStateSchema)` to create a new message.
 */
export const TransferStateSchema: GenMessage<TransferState> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer, 0);

/**
 * Whether a transfer can be recovered after its link expired.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.TransferState.RecoveryState
 */
export enum TransferState_RecoveryState {
  /**
   * No state given.
   *
   * @generated from enum value: RECOVERY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The link has not expired, so there is nothing to recover.
   *
   * @generated from enum value: RECOVERY_STATE_LIVE = 1;
   */
  LIVE = 1,

  /**
   * The link expired, the files are still kept and the one recovery is unspent. recoverable_until is the deadline.
   *
   * @generated from enum value: RECOVERY_STATE_RECOVERABLE = 2;
   */
  RECOVERABLE = 2,

  /**
   * The one recovery was spent and the link works again until expires_at. No second recovery exists.
   *
   * @generated from enum value: RECOVERY_STATE_RECOVERED = 3;
   */
  RECOVERED = 3,

  /**
   * The kept files were deleted when the window closed, and nothing can bring them back.
   *
   * @generated from enum value: RECOVERY_STATE_PURGED = 4;
   */
  PURGED = 4,

  /**
   * The transfer was never kept for recovery: its plan did not allow it, its sender did not switch recovery on, or it
   * stores nothing to recover.
   *
   * @generated from enum value: RECOVERY_STATE_INELIGIBLE = 5;
   */
  INELIGIBLE = 5,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.TransferState.RecoveryState.
 */
export const TransferState_RecoveryStateSchema: GenEnum<TransferState_RecoveryState> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_transfer, 0, 0);

/**
 * Whether files can be added to a transfer. This answers for the kind of transfer only; the plan's own allowance
 * is a separate question.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.TransferState.FileAdditionState
 */
export enum TransferState_FileAdditionState {
  /**
   * No state given.
   *
   * @generated from enum value: FILE_ADDITION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A live, complete, hosted transfer that is either plaintext or server-escrow accepts files.
   *
   * @generated from enum value: FILE_ADDITION_STATE_SUPPORTED = 1;
   */
  SUPPORTED = 1,

  /**
   * The transfer can never accept files, whatever the plan: a peer-to-peer one, a zero-knowledge one or one bound to
   * a file request.
   *
   * @generated from enum value: FILE_ADDITION_STATE_UNSUPPORTED = 2;
   */
  UNSUPPORTED = 2,

  /**
   * The transfer's own upload has not finished.
   *
   * @generated from enum value: FILE_ADDITION_STATE_INCOMPLETE = 3;
   */
  INCOMPLETE = 3,

  /**
   * The link has expired.
   *
   * @generated from enum value: FILE_ADDITION_STATE_EXPIRED = 4;
   */
  EXPIRED = 4,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.TransferState.FileAdditionState.
 */
export const TransferState_FileAdditionStateSchema: GenEnum<TransferState_FileAdditionState> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_transfer, 0, 1);

/**
 * Whether a transfer can be placed under legal hold now. This answers for the transfer only; the plan's own
 * allowance is a separate question.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.TransferState.LegalHoldState
 */
export enum TransferState_LegalHoldState {
  /**
   * No state given.
   *
   * @generated from enum value: LEGAL_HOLD_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Already held: the link does not expire and the transfer cannot be deleted until the hold is released.
   *
   * @generated from enum value: LEGAL_HOLD_STATE_HELD = 1;
   */
  HELD = 1,

  /**
   * Not held, and a hold would be honoured.
   *
   * @generated from enum value: LEGAL_HOLD_STATE_AVAILABLE = 2;
   */
  AVAILABLE = 2,

  /**
   * The transfer can never be held, whatever the plan: the storage it sits on cannot keep its files past their
   * purge date, or a peer-to-peer transfer stores none.
   *
   * @generated from enum value: LEGAL_HOLD_STATE_UNSUPPORTED = 3;
   */
  UNSUPPORTED = 3,

  /**
   * The transfer's own upload has not finished, so there is nothing to keep yet.
   *
   * @generated from enum value: LEGAL_HOLD_STATE_INCOMPLETE = 4;
   */
  INCOMPLETE = 4,

  /**
   * The link has already expired, so the files may already be gone.
   *
   * @generated from enum value: LEGAL_HOLD_STATE_EXPIRED = 5;
   */
  EXPIRED = 5,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.TransferState.LegalHoldState.
 */
export const TransferState_LegalHoldStateSchema: GenEnum<TransferState_LegalHoldState> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_transfer, 0, 2);

/**
 * One row of the owner's transfer list: a transfer's state with its files counted and sized instead of listed.
 *
 * @generated from message kitecorp.transferify.transfer.v1.TransferSummary
 */
export type TransferSummary = Message<"kitecorp.transferify.transfer.v1.TransferSummary"> & {
  /**
   * The transfer.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState state = 1;
   */
  state?: TransferState | undefined;

  /**
   * How many files the transfer holds, whatever their upload status.
   *
   * @generated from field: int32 file_count = 2;
   */
  fileCount: number;

  /**
   * The transfer's size in bytes: the sum over every file, whatever its upload status, of the size the sender picked.
   * An encrypted file counts without its framing.
   *
   * @generated from field: int64 total_bytes = 3;
   */
  totalBytes: bigint;

  /**
   * The name of the transfer's first file in its own file order, which titles the row. Absent when no file is left or
   * the first was recorded without a name.
   *
   * @generated from field: optional string first_file_name = 4;
   */
  firstFileName?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.TransferSummary.
 * Use `create(TransferSummarySchema)` to create a new message.
 */
export const TransferSummarySchema: GenMessage<TransferSummary> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer, 1);

/**
 * One file of an owner's transfer, as the expanded row lists it. It carries no download link and no key.
 *
 * @generated from message kitecorp.transferify.transfer.v1.TransferFile
 */
export type TransferFile = Message<"kitecorp.transferify.transfer.v1.TransferFile"> & {
  /**
   * The file's id, a UUID.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The file's declared name. Absent for a legacy file recorded without one.
   *
   * @generated from field: optional string filename = 2;
   */
  filename?: string | undefined;

  /**
   * The file's stored size in bytes. For an encrypted file whose upload began it is the size of the ciphertext.
   *
   * @generated from field: int64 length = 3;
   */
  length: bigint;

  /**
   * The digest recorded when the file was registered. Absent when none was.
   *
   * @generated from field: optional string hash = 4;
   */
  hash?: string | undefined;

  /**
   * The file's peer-to-peer identity. Absent for a hosted file.
   *
   * @generated from field: optional string magnet_uri = 5;
   */
  magnetUri?: string | undefined;

  /**
   * When the file was registered. Absent only for a file recorded without it.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Whether the file's bytes are stored encrypted.
   *
   * @generated from field: bool encrypted = 7;
   */
  encrypted: boolean;

  /**
   * The plaintext chunk size the file was encrypted with. Absent until an encrypted upload begins, and for a file
   * stored as it was sent.
   *
   * @generated from field: optional int32 cipher_chunk_size = 8;
   */
  cipherChunkSize?: number | undefined;

  /**
   * The file's folder path including its name. Absent for a file at the root.
   *
   * @generated from field: optional string relative_path = 9;
   */
  relativePath?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.TransferFile.
 * Use `create(TransferFileSchema)` to create a new message.
 */
export const TransferFileSchema: GenMessage<TransferFile> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer, 2);

/**
 * How long a transfer's download link works, the retention the sender chose. The values follow the order the retention
 * ladder is declared in, which is not the order a picker shows them in.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.ExpireAfter
 */
export enum ExpireAfter {
  /**
   * No retention given. A transfer recorded without one carries this.
   *
   * @generated from enum value: EXPIRE_AFTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * One day.
   *
   * @generated from enum value: EXPIRE_AFTER_ONE_DAY = 1;
   */
  ONE_DAY = 1,

  /**
   * Two days.
   *
   * @generated from enum value: EXPIRE_AFTER_TWO_DAYS = 2;
   */
  TWO_DAYS = 2,

  /**
   * Three days.
   *
   * @generated from enum value: EXPIRE_AFTER_THREE_DAYS = 3;
   */
  THREE_DAYS = 3,

  /**
   * Four days.
   *
   * @generated from enum value: EXPIRE_AFTER_FOUR_DAYS = 4;
   */
  FOUR_DAYS = 4,

  /**
   * Five days.
   *
   * @generated from enum value: EXPIRE_AFTER_FIVE_DAYS = 5;
   */
  FIVE_DAYS = 5,

  /**
   * Six days.
   *
   * @generated from enum value: EXPIRE_AFTER_SIX_DAYS = 6;
   */
  SIX_DAYS = 6,

  /**
   * Seven days.
   *
   * @generated from enum value: EXPIRE_AFTER_SEVEN_DAYS = 7;
   */
  SEVEN_DAYS = 7,

  /**
   * Two weeks.
   *
   * @generated from enum value: EXPIRE_AFTER_TWO_WEEKS = 8;
   */
  TWO_WEEKS = 8,

  /**
   * Three weeks.
   *
   * @generated from enum value: EXPIRE_AFTER_THREE_WEEKS = 9;
   */
  THREE_WEEKS = 9,

  /**
   * One month, thirty days.
   *
   * @generated from enum value: EXPIRE_AFTER_ONE_MONTH = 10;
   */
  ONE_MONTH = 10,

  /**
   * No expiry at all. Only a plan that allows it may choose it.
   *
   * @generated from enum value: EXPIRE_AFTER_NEVER = 11;
   */
  NEVER = 11,

  /**
   * Fifteen minutes.
   *
   * @generated from enum value: EXPIRE_AFTER_FIFTEEN_MINUTES = 12;
   */
  FIFTEEN_MINUTES = 12,

  /**
   * Thirty minutes.
   *
   * @generated from enum value: EXPIRE_AFTER_THIRTY_MINUTES = 13;
   */
  THIRTY_MINUTES = 13,

  /**
   * Forty-five minutes.
   *
   * @generated from enum value: EXPIRE_AFTER_FORTY_FIVE_MINUTES = 14;
   */
  FORTY_FIVE_MINUTES = 14,

  /**
   * One hour.
   *
   * @generated from enum value: EXPIRE_AFTER_ONE_HOUR = 15;
   */
  ONE_HOUR = 15,

  /**
   * Two hours.
   *
   * @generated from enum value: EXPIRE_AFTER_TWO_HOURS = 16;
   */
  TWO_HOURS = 16,

  /**
   * Four hours.
   *
   * @generated from enum value: EXPIRE_AFTER_FOUR_HOURS = 17;
   */
  FOUR_HOURS = 17,

  /**
   * Eight hours.
   *
   * @generated from enum value: EXPIRE_AFTER_EIGHT_HOURS = 18;
   */
  EIGHT_HOURS = 18,

  /**
   * Twelve hours.
   *
   * @generated from enum value: EXPIRE_AFTER_TWELVE_HOURS = 19;
   */
  TWELVE_HOURS = 19,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.ExpireAfter.
 */
export const ExpireAfterSchema: GenEnum<ExpireAfter> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_transfer, 0);

